var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './SeriesSDCC.scss';
import SeriesPoster from '../KodanshaUIKit/SeriesPoster/SeriesPoster';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import { GoodiesData } from './GoodiesDataSDCC';
import { useAtom } from 'jotai';
import { LoginStatusAtom } from '../../store/AccountStore';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import { Link, useHistory } from 'react-router-dom';
export var SeriesItem = function (_a) {
    var data = _a.data;
    var history = useHistory();
    var _b = __read(useAtom(LoginStatusAtom), 1), loginStatus = _b[0];
    var _c = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _c[1];
    var onButtonCLicked = function (e) {
        if (e.currentTarget.textContent === 'Sign up to read') {
            setLoginOverlay(true);
            return;
        }
    };
    return _jsxs("div", { className: 'series-item-wrapper', children: [_jsx(Link, { to: '/series/' + data.readableUrl, className: 'series-item-link', children: _jsx(SeriesPoster, { ratio: 120, isGray: false, color: data.color, src: data.image }) }), _jsxs("div", { className: 'series-item-info-wrapper', children: [_jsx("h5", { className: 'series-name', children: data.name }), _jsxs("span", { className: 'sx-author-name', children: ["By ", data.author] }), _jsx("div", { className: 'genres-wrapper', children: data.genres.map(function (genre, index, array) {
                            return _jsxs(_Fragment, { children: [_jsx("span", { children: genre }), index < array.length - 1 ? _jsx("span", { children: "/" }) : null] });
                        }) }), loginStatus === "LoggedIn" ? _jsx(Link, { to: {
                            pathname: '/reader/' + data.reader.toString(),
                            state: { returnPath: history.location.pathname },
                        }, children: _jsx(KodanshaUnderlinedText, { text: 'Read Chapter 1' }) }) :
                        _jsx(KodanshaUnderlinedText, { onClick: onButtonCLicked, text: 'Sign up to read' })] })] });
};
var SeriesSDCC = function () {
    return (_jsxs("div", { className: 'series-ax-container', children: [_jsx("h1", { className: 'header-one', children: "SDCC23 SPOTLIGHT SERIES" }), _jsx("h2", { className: 'header-two', children: "A guide to explore the world of manga" }), _jsx("h2", { className: 'until', children: "Up to 3 volumes of the following series were free-to-read until 7/25" }), _jsx("div", { className: 'series-ax-grid-wrapper', children: GoodiesData.map(function (data) { return _jsx(SeriesItem, { data: data }); }) })] }));
};
export default SeriesSDCC;
